import { CASHIER_FEATURE, USER_ROLE } from "../features/accounting/cash-management/cash-managment-constants";
import store from "../redux/store";

export const isUserCashier = () => {
    const userData = store.getState().businessReducer.userData
    
    const userAllowedFeatures = userData?.allowedFeatures;
    const isCashier = userAllowedFeatures?.includes(CASHIER_FEATURE[0]) 
    && userAllowedFeatures.includes(CASHIER_FEATURE[1])
    &&  userData.role === USER_ROLE

    return isCashier
}